import { apiConstants } from './shared/config';

const authAccess = { roles: ['PIM_00020'], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado' };

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao" */ './views/Home.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'home.title',
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'settings.titles',
        }
    },
    {
        path: `/${apiConstants.code}/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.titles`,
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/printinventories`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-printinventory" */ './views/printinventory/PrintInventoryBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.printinventories`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-printinventory" */ './views/printinventory/PrintInventoryList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Impressão Inventário',
                }
            },
            {
                path: 'config',
                name: `${apiConstants.code}.printinventories.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-printinventory" */ './views/printinventory/PrintInventoryConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Impressão Inventário',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.printinventories.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-printinventory" */ './views/printinventory/PrintInventoryDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Impressão Inventário',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.printinventories.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-printinventory" */ './views/printinventory/PrintInventoryDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Impressão Inventário',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Impressão Inventário',
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-print_visible_emissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pimgestao-print_visible_emissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
];

export default routes;